import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IDrawing } from '@obvious.tech/constellation'

export const Drawing = defineEntity('Drawing', {
  endpoint: 'geolocation/api/Drawing',
  schema: SNoop<IDrawing>(),
})
